class Ajax {
    constructor(config) {
        this.config = config;
        this.event = {

        };
        this.countTry = 3
    }
    isTry(){
        this.countTry --;
        return this.countTry >= 0
    }

    onBeforeSuccess(callback){
        this.event['onBeforeSuccess'] = callback;
        return this;
    }

    onAfterSuccess(callback){
        this.event['onAfterSuccess'] = callback;
        return this;
    }

    onSuccess(callback){
        this.event['onSuccess'] = callback;
        return this;
    }

    onFail(callback){
        this.event['onFail'] = callback;
        return this;
    }
    onFinal(callback){
        this.event['onFinal'] = callback;
        return this;
    }
    call(event, response) {
        if (!this.event[event]){
            return
        }
        this.event[event](response)
    }
    getConfig(){
        return this.config
    }
}

module.exports = Ajax;